import { SET_NETWORK_BROWSE_GROUPS_FETCHING } from 'actions';

export default function resetFetchStatus() {
  return {
    type: SET_NETWORK_BROWSE_GROUPS_FETCHING,
  };
}
